import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 15v-6a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4","key":"svg-0"}],["path",{"d":"M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9","key":"svg-1"}],["path",{"d":"M16 22l5 -5","key":"svg-2"}],["path",{"d":"M21 21.5v-4.5h-4.5","key":"svg-3"}],["path",{"d":"M16 9h2","key":"svg-4"}]]

const IconDevicesShare = createReactComponent('outline', 'devices-share', 'DevicesShare', __iconNode);

export default IconDevicesShare;